import { render, staticRenderFns } from "./HealthService.vue?vue&type=template&id=84e76236&scoped=true"
import script from "./HealthService.vue?vue&type=script&lang=js"
export * from "./HealthService.vue?vue&type=script&lang=js"
import style0 from "./HealthService.vue?vue&type=style&index=0&id=84e76236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e76236",
  null
  
)

export default component.exports